/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const orderModifierKind = {
  LIQUIDATION: 'LIQUIDATION',
  MAX_BUY: 'MAX_BUY',
} as const

export type OrderModifierKind = (typeof orderModifierKind)[keyof typeof orderModifierKind]
